import React, { useState } from 'react';
import { Input, Modal } from "antd";
import { ReactComponent as CloseSVG } from '../../../img/default-svg/close-black.svg';
import './style.scss';
import { useTranslation } from "react-i18next";
import Button from "../../../components/Button";
import { identity } from "../../../utils/getIdentity";

const RemoveRoleModal = ({ visible, close, deleteRole, getRolesList, removeId, removeName }) => {
  const { t } = useTranslation();

  const removeRole = () => {
    deleteRole(removeId);
    close();
    setTimeout(() => {
      getRolesList();
    }, 1000);
  }

  return (
    <Modal
      width={620}
      title=""
      visible={visible}
      onCancel={close}
      footer={null}
      className="checkout-modal"
      centered
      closeIcon={<CloseSVG />}
      destroyOnClose
      maskClosable={false}
    >
      <div className={`role-modal role-modal-${identity}`}>
        <div className={`role-modal__title role-modal__title-${identity}`}>{t('admin.remove_role')} {removeName} {t('admin.remove_role_last')}?</div>

        <Button onClick={removeRole} type="primary">{t('admin.remove')}</Button>
      </div>
    </Modal>
  )
};

export default RemoveRoleModal;